import axios from 'axios'

export async function getReservationRADetails(reservationNumber, pickupDate, pickupStation) {
  return (await axios.get(`/reservation/${reservationNumber}/rental-agreement`, { params: { pickupDate, pickupStation } })).data
}

export async function getRentalAgreementDocuments(raNumber) {
  return (await axios.get(`/rental-agreements/${raNumber}/documents`)).data
}

export async function downloadRentalAgreementDocument(raNumber, fileName) {
  return (await axios.get(`/rental-agreements/${raNumber}/documents/${fileName}`)).data
}
